<template>
  <div>
    <PageAllow
      controller="StockOuts"
      :action="isNew ? 'add' : isView ? 'view' : mode"
    />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color pa-4">
      <ValidationObserver ref="observer">
        <v-expansion-panels v-model="panels" multiple accordion>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-card-title class="ms-n4 py-0">
                {{
                  $t(isNew ? "CRUD.newInfo" : "CRUD.info", [
                    $t("StockOrderOUT.ObjectName"),
                  ])
                }}
                <v-chip
                  v-if="stock_outs.cancel_flg"
                  small
                  label
                  outlined
                  class="ms-4 mt-1"
                  color="danger"
                >
                  {{ $t("CRUD.cancelled") }}
                </v-chip>
                <v-chip
                  v-if="!isNew"
                  small
                  label
                  class="ms-4 mt-1"
                  :color="stock_outs.status | stockOrderOUTStatusColor"
                  :text-color="stock_outs.status | stockOrderOUTStatusTextColor"
                  >{{ stock_outs.status | stockOrderOUTStatusText }}
                </v-chip>
                <v-spacer />
                <v-sheet
                  class="pt-1 transparent-background-color d-inline-block"
                >
                  <v-btn
                    v-if="
                      isNew && $permission.permissionAllow('StockOuts', 'add')
                    "
                    small
                    dark
                    color="primary"
                    class="px-2 me-2 mb-1"
                    @click.stop="doSubmit()"
                  >
                    <v-icon x-small class="pe-1">fa-save</v-icon>
                    {{ $t("StockOrderOUT.actions.submitStockOut") }}
                  </v-btn>
                  <v-btn
                    v-if="
                      mode == 'edit' &&
                      $permission.permissionAllow('StockOuts', 'edit') &&
                      stock_outs.sorting_status != 1 &&
                      stock_outs.sorting_status != 2
                    "
                    small
                    dark
                    color="primary"
                    class="px-2 me-2 mb-1"
                    @click.stop="doSubmit()"
                  >
                    <v-icon x-small class="pe-1">fa-save</v-icon>
                    {{ $t("StockOrderOUT.actions.editStockOUTSubmit") }}
                  </v-btn>
                  <v-btn
                    v-if="
                      isStockOut &&
                      $permission.permissionAllow('StockOuts', 'out')
                    "
                    small
                    dark
                    color="action"
                    class="px-2 me-2 mb-1"
                    @click.stop="doSubmit('out')"
                  >
                    <v-icon x-small class="pe-1">fa-save</v-icon>
                    {{ $t("StockOrderOUT.actions.stockOut") }}
                  </v-btn>
                  <v-btn
                    v-if="
                      isStockOut &&
                      stock_outs.type == 1 &&
                      $permission.permissionAllow('StockOuts', 'partOut')
                    "
                    small
                    dark
                    color="primary"
                    class="px-2 me-2 mb-1"
                    @click.stop="doSubmit('part_out')"
                  >
                    {{ $t("StockOrderOUT.actions.stockPartOut") }}
                  </v-btn>
                </v-sheet>
                <StockOrderOUTActions
                  v-if="isView"
                  :stock_out="stock_outs"
                  :showComplete="
                    settings && !settings.stock_position_setting ? true : false
                  "
                  @stockOut="mode = 'out'"
                  @edit="mode = 'edit'"
                  @done="$router.push('/stock-orders-out')"
                  showEdit
                  :showLogistic="
                    $permission.permissionAllow(
                      'Requisitions',
                      'getRequisitionLogistic'
                    ) && stock_outs.type == 2
                  "
                  detail-mode
                  showApprove
                  showCancel
                />
              </v-card-title>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <v-divider />
              <v-row no-gutters class="mt-4 table-style">
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.stock_out_code")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_outs.stock_order_code }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.ext_code")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ stock_outs.ext_code }}
                    </span>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.stock_out_obj_name")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_outs.obj_name }}
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  v-if="!isNew && stock_outs.purchase_code"
                >
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.purchase_code")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <a
                      :href="'/#/purchases/detail/' + stock_outs.purchase_id"
                      style="text-decoration: none"
                    >
                      {{ stock_outs.purchase_code }}
                    </a>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.created_time")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_outs.created | formatTime }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.actual_time")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <SearcherDatetime
                      v-if="
                        mode == 'edit' &&
                        stock_outs.sorting_status != 1 &&
                        stock_outs.sorting_status != 2
                      "
                      class="my-n2"
                      v-model="stock_outs.actual_date"
                      type="datetime"
                      single-line
                      dense
                      hide-details
                    >
                    </SearcherDatetime>
                    <span v-else>
                      {{ stock_outs.actual_date | formatTime }}
                    </span>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.finish_time")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ stock_outs.finish_time | formatTime }}
                    </span>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" v-if="stock_outs.type == 1">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.expect_date")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <SearcherDatetime
                      class="my-n2"
                      v-if="editExpectDateFlg"
                      v-model="stock_outs.expect_date"
                      type="datetime"
                      single-line
                      dense
                      hide-details
                      disabled-before-today
                    />
                    <span v-else>
                      {{ stock_outs.expect_date | formatTime }}
                    </span>
                    <!-- 修改期望配送时间 -->
                    <v-btn
                      v-if="
                        (stock_outs.status == 1 || stock_outs.status == 2) &&
                        !isNew &&
                        !editExpectDateFlg &&
                        stock_outs.order_out_count == 1 &&
                        stock_outs.sorting_status != 1 &&
                        stock_outs.sorting_status != 2
                      "
                      small
                      dark
                      text
                      color="action"
                      class="mb-n2"
                      @click.stop="editExpectDateFlg = true"
                    >
                      <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
                      {{ $t("Order.actions.editExpectDate") }}
                    </v-btn>
                    <v-btn
                      v-if="editExpectDateFlg"
                      small
                      dark
                      text
                      color="action"
                      class="mb-n2"
                      @click.stop="editExpectDate()"
                    >
                      <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
                      {{ $t("CRUD.save") }}
                    </v-btn>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.stock_out_type")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <v-select
                      v-if="isNew"
                      v-model="stock_outs.type"
                      :items="
                        $consts.stock_out_order.types.filter(
                          (element) =>
                            element.value == 11 ||
                            element.value == 12 ||
                            element.value == 13 ||
                            element.value == 15 ||
                            element.value == 16
                        )
                      "
                      single-line
                      dense
                      hide-details
                      class="d-inline mt-0 mb-n1"
                    >
                    </v-select>
                    <span v-else>{{
                      stock_outs.type | stockOrderOUTTypesText
                    }}</span>
                  </v-card>
                </v-col>
                <v-col cols="12" :md="isNew || stock_outs.shop ? 4 : 8">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.stock_name")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <SearcherStock
                      v-if="isNew || replaceStock"
                      noLabel
                      v-model="stockSelected"
                      single-line
                      dense
                      hide-details
                      class="d-inline mt-0 mb-n1"
                      :stock-types="[0]"
                    />
                    <span v-else>
                      {{
                        stock_outs && stock_outs.stock
                          ? stock_outs.stock.name
                          : ""
                      }}
                    </span>
                    <v-btn
                      v-if="
                        (mode == 'edit' || isStockOut) &&
                        !replaceStock &&
                        stock_outs.type == 1 &&
                        stock_outs.sorting_status != 1 &&
                        stock_outs.sorting_status != 2
                      "
                      small
                      dark
                      text
                      color="action"
                      class="mb-n2"
                      @click.stop="replaceStock = true"
                    >
                      {{ $t("CRUD.rechooseInfo", [$t("Stock.ObjectName")]) }}
                    </v-btn>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" v-if="isNew">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.actual_time")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <SearcherDatetime
                      class="my-n2"
                      v-model="stock_outs.actual_date"
                      type="datetime"
                      single-line
                      dense
                      hide-details
                    >
                    </SearcherDatetime>
                  </v-card>
                </v-col>
                <v-col cols="12" md="12" v-if="isNew && stock_outs.type == 13">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.supplier")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <Required :show="savable" :mode="mode" />
                    <v-sheet width="100%">
                      <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('StockOrderOUT.Fields.supplier')"
                        rules="required"
                      >
                        <SearcherSupplier
                          v-model="supplier"
                          single-line
                          dense
                          hide-details
                          noLabel
                          :errorMessages="errors"
                        />
                      </ValidationProvider>
                    </v-sheet>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.creater")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_outs.creater_name }}
                  </v-card>
                </v-col>
                <!-- 配送点名称 -->
                <v-col
                  cols="12"
                  md="4"
                  v-if="
                    settings &&
                    settings.delivery_point &&
                    !isNew &&
                    stock_outs.type == 1
                  "
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.delivery_point")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span v-if="stock_outs.delivery_point_province_id">
                      {{
                        $t("StockOrderOUT.Fields.delivery_point_name", [
                          stock_outs.delivery_point_code,
                          stock_outs.delivery_point_name,
                        ])
                      }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 配送点负责人 -->
                <v-col
                  cols="12"
                  md="4"
                  v-if="
                    settings &&
                    settings.delivery_point &&
                    !isNew &&
                    stock_outs.type == 1
                  "
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.delivery_point_manager")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ stock_outs.delivery_point_manager }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 配送点联系方式 -->
                <v-col
                  cols="12"
                  md="4"
                  v-if="
                    settings &&
                    settings.delivery_point &&
                    !isNew &&
                    stock_outs.type == 1
                  "
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.delivery_point_tel")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ stock_outs.delivery_point_tel }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 配送点地址 -->
                <v-col
                  cols="12"
                  md="12"
                  v-if="
                    settings &&
                    settings.delivery_point &&
                    !isNew &&
                    stock_outs.type == 1
                  "
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.delivery_point_address")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ stock_outs.delivery_point_full_address }}
                    </span>
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  class="d-inline d-md-none"
                  v-if="!isNew"
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.operater_name")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_outs.operater_name }}
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  class="d-inline d-md-none"
                  v-if="!isNew"
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.executer_name")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_outs.executer_name }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" v-if="!isNew && stock_outs.shop">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.receiver")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{
                      receiverInfo
                        ? receiverInfo.user_name
                        : stock_outs &&
                          stock_outs.shop &&
                          stock_outs.shop.shop_user
                        ? stock_outs.shop.shop_user.name
                        : ""
                    }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" v-if="!isNew && stock_outs.shop">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.receiver_tel")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{
                      receiverInfo
                        ? receiverInfo.tel
                        : stock_outs &&
                          stock_outs.shop &&
                          stock_outs.shop.shop_user
                        ? stock_outs.shop.shop_user.tel
                        : ""
                    }}
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  class="d-none d-md-inline"
                  v-if="!isNew"
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.operater_name")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_outs.operater_name }}
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="8"
                  v-if="!isNew && stock_outs && stock_outs.shop"
                >
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{
                        $t("StockOrderOUT.Fields.shop_address", [
                          $consts.shopName(),
                        ])
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span
                      v-if="
                        order && order.order_extra && order.order_extra.express
                      "
                    >
                      {{
                        $t("Order.Fields.receiver_address_format", [
                          order.order_extra.express.receiver_province,
                          order.order_extra.express.receiver_city,
                          order.order_extra.express.receiver_area,
                          order.order_extra.express.receiver_address,
                        ])
                      }}
                    </span>
                    <span v-else-if="receiverInfo">{{
                      receiverInfo.address
                    }}</span>
                    <AddressText
                      v-else
                      :masterItem="stock_outs.shop"
                      :detailAddress="stock_outs.shop.address"
                    />
                    <!-- 切换地址按钮 -->
                    <v-btn
                      v-if="
                        $permission.permissionAllow('ShopAddress', 'view') &&
                        (savable || isView) &&
                        stock_outs &&
                        stock_outs.shop &&
                        stock_outs.shop.id &&
                        stock_outs.type == 1 &&
                        stock_outs.actions &&
                        stock_outs.actions.edit_address &&
                        !isStockOut
                      "
                      small
                      dark
                      text
                      color="action"
                      class="mb-n2"
                      @click.stop="selectShopAddressDialog = true"
                    >
                      <v-icon x-small class="pe-1">fa-store</v-icon>
                      {{ $t("Order.address.resetAddress") }}
                    </v-btn>
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  class="d-none d-md-inline"
                  v-if="!isNew"
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.executer_name")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_outs.executer_name }}
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  v-if="stock_outs && stock_outs.type == 11"
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.broken_type")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <Required :show="savable" :mode="mode" />
                    <v-sheet v-if="savable" width="100%">
                      <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('StockOrderOUT.Fields.broken_type')"
                        rules="required"
                      >
                        <v-select
                          v-model="stock_outs.broken_type"
                          :items="$consts.stock_out_order.brokenType"
                          single-line
                          dense
                          hide-details
                          :error-messages="errors"
                          class="d-inline mt-0 mb-n1"
                        >
                        </v-select>
                      </ValidationProvider>
                    </v-sheet>
                    <span v-else>{{
                      stock_outs.broken_type | stockOrderOUTBrokenTypeText
                    }}</span>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" v-if="stock_outs.type == 12">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.picking_user")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <SearcherAccountUser
                      v-if="isNew || mode == 'edit'"
                      v-model="stock_outs.picking_user_id"
                      :type="[2]"
                      notReturnObject
                      description
                      noLabel
                      dense
                      unclearable
                    />
                    <span v-else>{{ stock_outs.picking_user_name }}</span>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="8" v-if="stock_outs.type == 11">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text"
                      >{{ $t("StockOrderOUT.Fields.breakage_reason")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <v-sheet
                      v-if="
                        savable &&
                        stock_outs.sorting_status != 1 &&
                        stock_outs.sorting_status != 2
                      "
                      width="100%"
                    >
                      <v-text-field
                        v-model="stock_outs.memo"
                        single-line
                        dense
                        hide-details
                        class="mt-0 mb-n1"
                      />
                    </v-sheet>
                    <span v-else>
                      {{ stock_outs.memo }}
                    </span>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="12" v-if="stock_outs.type == 1">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("Order.Fields.memo", [$consts.shopName()])
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ order.memo }}
                    </span>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="12" v-if="stock_outs.type == 1">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text"
                      >{{ $t("StockOrderOUT.Fields.account_memo")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ stock_outs.account_memo }}
                    </span>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.attachment") }}{{ $t("Global.colon") }}
                    </span>
                    <v-text-field
                      v-if="
                        (savable &&
                        stock_outs.sorting_status != 1 &&
                        stock_outs.sorting_status != 2) || edit_attachment
                      "
                      v-model="stock_outs.attachment"
                      single-line
                      dense
                      hide-details
                      class="d-inline mt-0 mb-n1"
                    />
                    <span v-else style="overflow-wrap: break-word;white-space: pre-wrap">
                      {{ stock_outs.attachment }}
                    </span>
                    <v-btn
                      v-if="!savable &&!edit_attachment &&
                        stock_outs.type != 1 &&
                        !productionStockOUTFlg &&
                        !orderStockOUTFlg
                      "
                      small
                      dark
                      text
                      color="action"
                      class="mb-n2"
                      @click.stop="edit_attachment = true"
                    >
                      <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
                      {{ $t("StockOrderOUT.actions.editAttachment") }}
                    </v-btn>
                    <v-btn
                      v-if="edit_attachment"
                      small
                      dark
                      text
                      color="action"
                      class="mb-n2"
                      @click.stop="saveAttachment()"
                    >
                      <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
                      {{ $t("CRUD.save") }}
                    </v-btn>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="12" v-if="stock_outs.type == 13">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text"
                      >{{ $t("StockOrderOUT.Fields.return_reason")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <Required :show="savable" :mode="mode" />
                    <v-sheet v-if="savable" width="100%">
                      <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('StockOrderOUT.Fields.return_reason')"
                        rules="required"
                      >
                        <v-text-field
                          v-model="stock_outs.memo"
                          single-line
                          dense
                          :hide-details="!errors || errors.length == 0"
                          class="mt-0 mb-n1"
                          :error-messages="errors"
                        />
                      </ValidationProvider>
                    </v-sheet>
                    <span v-else>
                      {{ stock_outs.memo }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 报损和退货附件上传 -->
                <!-- 要货出库、领料出库、其他出库、调拨出库附件上传 -->
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  v-if="
                    stock_outs.type == 11 ||
                    stock_outs.type == 13 ||
                    stock_outs.type == 1 ||
                    stock_outs.type == 12 ||
                    stock_outs.type == 15 ||
                    stock_outs.type == 16 ||
                    stock_outs.type == 2
                  "
                >
                  <v-card
                    class="pa-2 d-flex overflow-auto text-no-wrap"
                    outlined
                    tile
                  >
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.attachments")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <!-- 上传图片集 -->
                    <span class="ml-4">
                      <v-card
                        height="160"
                        width="240"
                        v-if="album && album.length > 0"
                      >
                        <v-carousel
                          hide-delimiters
                          cycle
                          height="160"
                          width="240"
                        >
                          <v-carousel-item
                            v-for="(item, i) in album"
                            :key="i"
                            :src="item"
                            @click.stop="$showFullscreenImages(album, i)"
                          >
                            <v-tooltip right v-if="savable && item">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-bind="attrs"
                                  v-on="on"
                                  color="secondary"
                                  class="pa-2 float-right"
                                  @click.stop="removeFromImages(i)"
                                  v-if="isNew"
                                >
                                  fa-times
                                </v-icon>
                              </template>
                              <span> {{ $t("Material.delImg") }}</span>
                            </v-tooltip>
                          </v-carousel-item>
                        </v-carousel>
                      </v-card>
                      <v-file-input
                        ref="imgs_file"
                        v-show="
                          savable &&
                          stock_outs.sorting_status != 1 &&
                          stock_outs.sorting_status != 2
                        "
                        show-size
                        counter
                        small-chips
                        multiple
                        suffix
                        prepend-icon="fa-camera"
                        accept="image/png, image/jpeg"
                        persistent-hint
                        :placeholder="$t('Material.imgsPlaceholder')"
                        :hint="$t('Material.imgsHint')"
                        :rules="imgsRules"
                        v-model="imgs_file"
                      >
                      </v-file-input>
                    </span>
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                  md="4"
                  v-if="
                    stock_outs.type == 1 &&
                    settings &&
                    settings.platform_yi_sorting == 1
                  "
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.estimated_express")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <v-text-field
                      v-if="edit_estimated_express"
                      v-model="stock_outs.estimated_express"
                      :placeholder="
                        String(
                          $numberFormatter.formatTwoDot(
                            stock_outs.estimated_express,
                            2
                          )
                        )
                      "
                      single-line
                      dense
                      type="number"
                      min="0"
                      :prefix="$t('Global.money')"
                      @blur="
                        stock_outs.estimated_express =
                          stock_outs.estimated_express == ''
                            ? stock_outs.estimated_express
                            : $numberFormatter.formatMoneyFloor(
                                stock_outs.estimated_express
                              )
                      "
                      @input="Number(stock_outs.estimated_express)"
                      hide-details
                      class="d-inline mt-0 mb-n1"
                    />
                    <span v-else>
                      {{ $t("Global.money") }}
                      {{ stock_outs.estimated_express | formatMoneyFloor }}
                    </span>
                    <v-btn
                      v-if="
                        !edit_estimated_express &&
                        settings &&
                        settings.platform_yi_sorting == 1 &&
                        settings.push_platform_setting[1023] &&
                        settings.push_platform_setting[1023].stocks &&
                        settings.push_platform_setting[1023].stocks.find(
                          (id) => stock_outs.stock_id == id
                        )
                      "
                      small
                      dark
                      text
                      color="action"
                      class="mb-n2"
                      @click.stop="edit_estimated_express = true"
                    >
                      <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
                      {{ $t("Order.actions.editEstimatedExpress") }}
                    </v-btn>
                    <v-btn
                      v-if="edit_estimated_express"
                      small
                      dark
                      text
                      color="action"
                      class="mb-n2"
                      @click.stop="saveEstimatedExpress()"
                    >
                      <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
                      {{ $t("CRUD.save") }}
                    </v-btn>
                  </v-card>
                </v-col>
                <!-- 调拨单运费 -->
                <v-col
                  cols="12"
                  sm="4"
                  md="4"
                  v-if="
                    stock_outs.type == 2 &&
                    stock_outs.status != 3 &&
                    settings &&
                    settings.requisition_express_price == 1
                  "
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.express_price")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <v-text-field
                      v-if="edit_express_price"
                      v-model="express_price"
                      :placeholder="
                        String($numberFormatter.formatTwoDot(express_price, 2))
                      "
                      single-line
                      dense
                      type="number"
                      min="0"
                      :prefix="$t('Global.money')"
                      @blur="
                        express_price =
                          express_price == ''
                            ? express_price
                            : $numberFormatter.formatMoneyFloor(express_price)
                      "
                      @input="Number(express_price)"
                      hide-details
                      class="d-inline mt-0 mb-n1"
                    />
                    <span v-else>
                      {{ $t("Global.money") }}
                      {{ express_price | formatMoneyFloor }}
                    </span>
                    <v-btn
                      v-if="!edit_express_price"
                      small
                      dark
                      text
                      color="action"
                      class="mb-n2"
                      @click.stop="edit_express_price = true"
                    >
                      <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
                      {{ $t("Order.actions.editExpressPrice") }}
                    </v-btn>
                    <v-btn
                      v-if="edit_express_price"
                      small
                      dark
                      text
                      color="action"
                      class="mb-n2"
                      @click.stop="saveExpressPrice()"
                    >
                      <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
                      {{ $t("CRUD.save") }}
                    </v-btn>
                  </v-card>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel v-if="!isNew">
            <v-expansion-panel-header class="py-0">
              <v-tabs v-model="tab" background-color="transparent">
                <v-tab
                  @click.stop="
                    tab = 0;
                    panels.find((p) => p == 1) ? null : panels.push(1);
                  "
                >
                  {{ $t("Order.actions.activities") }}
                </v-tab>
                <v-tab
                  v-if="
                    stock_outs.type == 2 ||
                    stock_outs.type == 3 ||
                    stock_outs.type == 4 ||
                    stock_outs.type == 13
                  "
                  @click.stop="
                    tab = 1;
                    panels.find((p) => p == 1) ? null : panels.push(1);
                  "
                >
                  {{ $t("Order.actions.relations") }}
                </v-tab>
              </v-tabs>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-card flat>
                    <v-data-table
                      :headers="activitiesHeaders"
                      :items="stock_out_activities"
                      class="elevation-0"
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:item.created="{ item }">
                        <span class="text-no-wrap">
                          {{ item.created | formatTime }}
                        </span>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card v-if="stock_outs.type == 2" flat>
                    <v-data-table
                      :headers="relationsHeaders"
                      :items="relations"
                      class="elevation-0"
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:item.relations_name="{ item }">
                        {{ item.identify_name }}
                      </template>
                      <template v-slot:item.identify_code="{ item }">
                        <a
                          v-if="item.controller == 'Requisitions'"
                          @click="$router.push('/requisitions/' + item.id)"
                        >
                          {{ item.identify_code }}
                        </a>
                      </template>
                      <template v-slot:item.created="{ item }">
                        <span class="text-no-wrap">
                          {{ item.created | formatTime }}
                        </span>
                      </template>
                    </v-data-table>
                  </v-card>
                  <v-card v-if="stock_outs.type == 3" flat>
                    <v-data-table
                      :headers="relationsHeaders"
                      :items="relations"
                      class="elevation-0"
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:item.relations_name>
                        {{ $t("StockTakeOrders.ObjectName") }}
                      </template>
                      <template v-slot:item.created="{ item }">
                        <span class="text-no-wrap">
                          {{ item.created | formatTime }}
                        </span>
                      </template>
                      <template v-slot:item.stock_take_code="{ item }">
                        <span class="text-no-wrap">
                          <a
                            @click="
                              $router.push('/stock-take-orders/' + item.id)
                            "
                          >
                            {{ item.stock_take_code }}
                          </a>
                        </span>
                      </template>
                    </v-data-table>
                  </v-card>
                  <v-card v-if="stock_outs.type == 4" flat>
                    <v-data-table
                      :headers="relationsHeaders"
                      :items="production_plan_relations"
                      class="elevation-0"
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:item.relations_name="{ item }">
                        {{ item.identify_name }}
                      </template>
                      <template v-slot:item.created="{ item }">
                        <span class="text-no-wrap">
                          {{ item.created | formatTime }}
                        </span>
                      </template>
                      <template v-slot:item.stock_take_code="{ item }">
                        <span class="text-no-wrap">
                          {{ item.identify_code }}
                        </span>
                      </template>
                      <template v-slot:item.status="{ item }">
                        <v-chip
                          v-if="item.controller == 'ProductionPlans'"
                          small
                          label
                          class="ms-4 mt-1"
                          :color="item.status | productionPlansStatusColor"
                          :text-color="
                            item.status | productionPlansStatusTextColor
                          "
                          >{{ item.status | productionPlansStatusText }}
                        </v-chip>
                      </template>
                      <template v-slot:item.actions="{ item }">
                        <v-btn
                          v-if="
                            $permission.permissionAllow(item.controller, 'view')
                          "
                          small
                          outlined
                          color="info"
                          class="px-2 me-2"
                          :href="'/#/' + item.identify + '/' + item.id"
                        >
                          <v-icon x-small class="pe-1">fa-align-left</v-icon>
                          {{ $t("Opt.details") }}
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-card>
                  <v-card v-if="stock_outs.type == 13" flat>
                    <v-data-table
                      :headers="relationsHeaders"
                      :items="relations"
                      class="elevation-0"
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:item.relations_name="{ item }">
                        {{ item.identify_name }}
                      </template>
                      <template v-slot:item.identify_code="{ item }">
                        <a
                          v-if="item.controller == 'Receipt'"
                          @click="$router.push('/receipts/' + item.id)"
                        >
                          {{ item.identify_code }}
                        </a>
                        <a
                          v-if="item.controller == 'FinanceBills'"
                          @click="
                            $router.push(
                              '/finance-bills-purchaseReturn/' + item.id
                            )
                          "
                        >
                          {{ item.identify_code }}
                        </a>
                      </template>
                      <template v-slot:item.created="{ item }">
                        <span class="text-no-wrap">
                          {{ item.created | formatTime }}
                        </span>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-data-table
          id="order_details_table"
          :headers="detailsHeaders"
          :items="stockOutDetails"
          :search="filter"
          multi-sort
          class="elevation-2 px-4 mt-4"
          disable-pagination
          hide-default-footer
          :no-data-text="$t('Order.DetailNoData')"
          :sort-by.sync="sortArr"
          :sort-desc.sync="sortDescArr"
        >
          <template v-slot:top>
            <v-toolbar flat class="transparent-background-color">
              <v-toolbar-title class="ms-n2">
                {{ $t("CRUD.details", [$t("StockOrderOUT.ObjectName")]) }}
              </v-toolbar-title>
              <v-spacer />
              <span>
                <span class="font-weight-bold me-2"
                  >{{ $t("StockOrderOUT.sum_price")
                  }}{{ $t("Global.colon") }}</span
                >
                {{ $t("Global.money") }}
                {{ total | formatMoneyFloor }}
              </span>
              <v-btn
                v-if="isNew && (stock_outs.stock_id && stock_outs.type ? true : false)"
                small
                color="print"
                dark
                @click.stop="importDialog = true"
                class="px-2 me-2 mb-1 mx-1 float-end"
              >
                <v-icon x-small class="pe-1">fa-file-import</v-icon>
                {{ $t("StockOrderOUT.importMaterials") }}
              </v-btn>
              <v-btn
                color="primary"
                small
                dark
                class="px-2 me-2 mb-1 mx-1"
                v-if="
                  savable &&
                  stock_outs.type != 4 &&
                  stock_outs.type != 17 &&
                  stock_outs.sorting_status != 1 &&
                  stock_outs.sorting_status != 2
                "
                @click="stockMaterialsDialog = true"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.chooseInfo", [$t("Material.ObjectName")]) }}
              </v-btn>
            </v-toolbar>
            <v-divider />
            <v-toolbar
              flat
              class="transparent-background-color"
              align-self="center"
            >
              <span class="caption secondary--text pt-2">
                {{
                  $t(
                    "$vuetify.dataFooter.pageText",
                    stock_outs.stock_order_details
                      ? [
                          1,
                          stock_outs.stock_order_details.length,
                          stock_outs.stock_order_details.length,
                        ]
                      : [0, 0, 0]
                  )
                }}
              </span>
              <v-spacer />
              <v-row no-gutters class="me-n3">
                <v-spacer />
                <v-col cols="12" sm="9" md="8">
                  <v-text-field
                    v-model="filter"
                    clearable
                    hide-details
                    :label="$t('Search.filter')"
                  />
                </v-col>
              </v-row>
            </v-toolbar>
          </template>
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>

          <template v-slot:item.Description="{ item }">
            <a
              class="text-no-wrap"
              :class="item.error_flg ? 'red--text' : ''"
              @click.stop="dialogMaterialID = item.material_id"
            >
              {{ item.material_name }}
            </a>
            <br />
            <span class="caption secondary--text">
              {{ $t("Material.Fields.standard") }}{{ $t("Global.colon") }}
              <span
                v-if="item.standard_name && item.standard_name.length > 12"
                :title="item.standard_name"
                style="cursor: pointer"
              >
                {{ item.standard_name.slice(0, 12) + "......" }}
              </span>
              <span v-else>
                {{ item.standard_name }}
              </span>
            </span>
          </template>
          <template v-slot:item.unit="{ item }">
            <v-select
              v-if="(isNew || item.new) && item.standard_details.length > 1"
              :items="item.standard_details"
              v-model="item.standard_detail_id"
              item-text="unit"
              item-value="id"
              noLabel
              single-line
              dense
              hide-details
              style="max-width: 60px"
              @change="resetPrice(item)"
            ></v-select>
            <span v-else> {{ item.unit }} </span>
          </template>
          <template v-slot:item.current_count="{ item }">
            {{ item.current_count_with_unit }}

            <!-- <span>
              {{ item.current_count }}
              {{
                item.material
                  ? item.material.standard
                    ? item.material.standard.default_standard_detail
                      ? item.material.standard.default_standard_detail.unit
                      : ""
                    : ""
                  : ""
              }}
            </span> -->
          </template>
          <template v-slot:item.requisition_price="{ item }">
            {{ $t("Global.money") }}
            {{ item.requisition_price | formatMoney }}
          </template>
          <template v-slot:item.order_num="{ item }">
            <NumberInput
              v-if="
                savable &&
                stock_outs.type != 1 &&
                stock_outs.type != 2 &&
                (stock_outs.type != 13 ||
                  (stock_outs.type == 13 && !isStockOut))
              "
              v-model="item.order_num"
              dense
            />
            <span v-else> {{ item.order_num | formatTwoDot }} </span>
          </template>
          <template v-slot:item.confirm_num="{ item }">
            <NumberInput
              v-if="
                ((mode == 'edit' && stock_outs.type == 1) ||
                  (productionStockOUTFlg && isStockOut)) &&
                stock_outs.sorting_status != 1 &&
                stock_outs.sorting_status != 2
              "
              v-model="item.confirm_num"
              dense
            />
            <span v-else>
              {{ item.confirm_num | formatTwoDot }}
            </span>
          </template>
          <template v-slot:item.stock_confirm_num="{ item }">
            <!-- 库存单位数量 -->
            {{ item.stock_current_count }}{{ item.stock_unit }}
          </template>
          <template v-slot:item.out_num="{ item }">
            <ValidationProvider
              v-if="
                mode == 'out' && (stock_outs.type == 1 || stock_outs.type == 2)
              "
              v-slot="{ errors }"
              :rules="
                isEditNumEnable && stock_outs.type == 1 && !item.new
                  ? {
                      sub_num: {
                        sub_num: item.confirm_num,
                      },
                    }
                  : null
              "
            >
              <NumberInput
                :error-messages="errors"
                v-model="item.out_num"
                dense
              />
            </ValidationProvider>
            <span v-else>
              {{ item.out_num | formatTwoDot }}
            </span>
          </template>
          <template v-slot:item.price="{ item }">
            <v-text-field
              v-if="
                (isNew &&
                  (stock_outs.type != 13 ||
                    (stock_outs.type == 13 &&
                      settings &&
                      settings.purchase_subtotal != 1))) ||
                (mode == 'edit' &&
                  (stock_outs.type == 11 ||
                    stock_outs.type == 12 ||
                    (stock_outs.type == 13 &&
                      settings &&
                      settings.purchase_subtotal != 1) ||
                    stock_outs.type == 15 ||
                    stock_outs.type == 16)) ||
                (mode == 'out' &&
                  stock_outs.type == 13 &&
                  settings &&
                  settings.purchase_subtotal != 1) ||
                (item.new &&
                  stock_outs.type == 1 &&
                  !settings.sub_account_enable)
              "
              v-model="item.price"
              single-line
              dense
              hide-details
              type="number"
              min="0"
              :prefix="$t('Global.money')"
              @blur="
                item.price = $numberFormatter.formatWithDotNoMoreThan(
                  item.price,
                  2
                )
              "
              style="max-width: 80px; margin-left: auto"
            />
            <span v-else>
              {{ $t("Global.money") }}
              {{ item.price | formatMoney }}
            </span>
          </template>
          <template v-slot:item.total="{ item }">
            <v-text-field
              v-if="
                savable &&
                stock_outs.type == 13 &&
                settings &&
                settings.purchase_subtotal == 1
              "
              v-model="item.total"
              :placeholder="
                $numberFormatter.formatMoneyFloor(item.total, 2) + ''
              "
              single-line
              dense
              hide-details
              type="number"
              min="0"
              :prefix="$t('Global.money')"
              @blur="
                item.total = $numberFormatter.formatMoneyFloor(item.total, 2)
              "
              style="max-width: 80px; margin-left: auto"
            />
            <span v-else>
              {{ $t("Global.money") }}
              {{ item.total | formatMoney }}
            </span>
          </template>
          <template v-slot:item.production_date="{ item }">
            {{ item.production_date | formatDate }}
          </template>
          <template v-slot:item.expired_date="{ item }">
            {{ item.expired_date | formatDate }}
          </template>
          <template v-slot:item.count_unit="{ item }">
            {{ item.count_unit_num | formatTwoDot
            }}{{ item.standard_detail.count_unit }}
          </template>
          <template v-slot:item.memo="{ item }">
            <v-text-field
              v-if="savable || item.edit_memo"
              v-model="item.memo"
              single-line
              dense
              hide-details
              style="max-width: 120px"
            >
              <template v-slot:append>
                <v-icon
                  x-small
                  @click.stop="
                    detail_memo_item = item;
                    memo_dialog = true;
                  "
                    class="pt-2 pb-1 primary--text"
                >
                  fa-edit
                </v-icon>
                <v-icon
                  v-if="!savable"
                  x-small
                  @click.stop="saveAttachment(item)"
                  class="pt-2 pb-1 primary--text ml-2"
                >
                  fa-check
                </v-icon>
              </template>
            </v-text-field>
            <span v-else>
              <span
                v-if="item.memo && item.memo.length > 6"
                :title="item.memo"
                style="cursor: pointer"
              >
                {{ item.memo.slice(0, 6) + "......" }}
              </span>
              <span v-else>
                {{ item.memo }}
              </span>
              <v-icon
                v-if="
                  !item.edit_memo &&
                  stock_outs.type != 1 &&
                  !productionStockOUTFlg &&
                  !orderStockOUTFlg
                "
                x-small
                color="primary"
                class=""
                style="display: inline-block"
                @click.stop="setEditMemoFlg(item)"
              >fa-pencil-alt
              </v-icon>
            </span>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              v-if="item.new"
              small
              text
              class="danger--text pa-0"
              @click.stop="
                stock_out_details.splice(
                  stock_out_details.findIndex((detail) =>
                    item.id ? item.id == detail.id : item.new == detail.new
                  ),
                  1
                )
              "
            >
              <v-icon>fa-times</v-icon>
            </v-btn>
          </template>

          <template v-if="!isNew" v-slot:body.prepend>
            <tr no-gutters class="d-none d-sm-table-row">
              <td
                class="secondary--text"
                :colspan="stock_outs.type == 2 ? (!isView ? 4 : 5) : 5"
              >
                {{ $t("StockOrderOUT.DetailFields.count_num") }}
              </td>

              <td class="align-end text-right" v-if="!productionStockOUTFlg">
                {{ stock_outs.order_num_count | formatTwoDot }}
              </td>
              <td
                v-if="
                  (isView ||
                    (!isNew &&
                      (stock_outs.type == 1 ||
                        stock_outs.type == 2 ||
                        productionStockOUTFlg))) &&
                  ((!isNew &&
                    (stock_outs.type == 1 || productionStockOUTFlg)) ||
                    isView)
                "
                class="align-end text-right"
              >
                {{ stock_outs.confirm_num_count | formatTwoDot }}
              </td>
              <td
                v-if="
                  (isView ||
                    (!isNew &&
                      (stock_outs.type == 1 ||
                        stock_outs.type == 2 ||
                        stock_outs.type == 13 ||
                        productionStockOUTFlg))) &&
                  (isView || (!isNew && !productionStockOUTFlg))
                "
                class="align-end text-right"
              >
                {{ stock_outs.out_num_count | formatTwoDot }}
              </td>
              <td></td>
              <td v-if="settings && settings.count_unit == 1"></td>
              <td v-if="stock_outs.type == 1"></td>
              <td
                v-if="
                  !savable &&
                  settings &&
                  settings.qualify_report_enable == 1 &&
                  settings.out_qualify_report_enable == 1
                "
                class="secondary--text"
              ></td>
              <td v-if="stock_outs.type == 13"></td>
              <td></td>
              <td v-if="stock_outs.type != 1 && !productionStockOUTFlg && !orderStockOUTFlg"></td>
            </tr>
            <tr no-gutters class="d-table-row d-sm-none">
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{
                    $t("StockOrderOUT.DetailFields.stock_out_order_num_count")
                  }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ stock_outs.order_num_count | formatTwoDot }}
                </div>
              </td>
              <td
                v-if="
                  (isView ||
                    (!isNew &&
                      (stock_outs.type == 1 || stock_outs.type == 2))) &&
                  ((!isNew && stock_outs.type == 1) || isView)
                "
                class="v-data-table__mobile-row"
              >
                <div class="v-data-table__mobile-row__header">
                  {{
                    $t("StockOrderOUT.DetailFields.stock_out_confirm_num_count")
                  }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ stock_outs.confirm_num_count | formatTwoDot }}
                </div>
              </td>
              <td
                v-if="
                  isView ||
                  (!isNew &&
                    (stock_outs.type == 1 ||
                      stock_outs.type == 2 ||
                      stock_outs.type == 13))
                "
                class="v-data-table__mobile-row"
              >
                <div class="v-data-table__mobile-row__header">
                  {{
                    $t(
                      "StockOrderOUT.DetailFields.stock_out_practical_num_count"
                    )
                  }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ stock_outs.out_num_count | formatTwoDot }}
                </div>
              </td>
              <td v-if="stock_outs.type != 1 && !productionStockOUTFlg && !orderStockOUTFlg"></td>
            </tr>
          </template>

          <template v-slot:item.qualify_report_img="{ item }">
            <!-- 质检报告 -->
            <v-btn
              v-if="
                stock_outs &&
                stock_outs.status == 3 &&
                item &&
                item.qualify_report_img_url &&
                item.qualify_report_img_url.length
              "
              color="orange"
              style="color: white"
              class="my-1"
              small
              @click.stop="
                currentItem = item;
                qualifyReportDialog = true;
              "
            >
              {{ $t("PurchasesDetail.purchaseFields.qualify_report") }}
            </v-btn>
          </template>

          <template v-slot:footer>
            <v-row
              v-if="
                (mode == 'new' ||
                  mode == 'edit' ||
                  (mode == 'out' &&
                    stock_outs.type == 1 &&
                    isAddMaterialEnable) ||
                  (mode == 'out' &&
                    stock_outs.type != 1 &&
                    stock_outs.type != 13)) &&
                stock_outs.type != 4 &&
                stock_outs.type != 17 &&
                stock_outs.sorting_status != 1 &&
                stock_outs.sorting_status != 2
              "
              no-gutters
              align="center"
              class="ps-1 text-no-wrap d-flex"
            >
              <span class="secondary--text">
                {{ $t("CRUD.newInfo", [$t("Material.ObjectName")])
                }}{{ $t("Global.colon") }}
              </span>
              <SearcherStockMaterial
                v-model="selectMaterial"
                :stock-id="
                  stock_outs.stock_id && stock_outs.type
                    ? stock_outs.stock_id
                    : null
                "
                :typeFlg="'stockOrdersOut'"
                :disabledItems="
                  stock_out_details
                    ? stock_out_details.map((detail) => {
                        return { material_id: detail.material_id };
                      })
                    : []
                "
                :status="[1]"
                no-label
              />
            </v-row>
          </template>
        </v-data-table>
      </ValidationObserver>
    </v-sheet>

    <MaterialDialog v-model="dialogMaterialID" />
    <ErrorMaterialsAlert
      v-model="errorMaterialInfoAlert"
      :materialArr="errorMaterialsList"
      :title="errorMsg"
    />

    <!-- 选择客户地址的弹窗 -->
    <DialogShopAddress
      v-model="selectShopAddressDialog"
      :shop_id="stock_outs.shop && stock_outs.shop.id ? stock_outs.shop.id : 0"
      :order_extra="order && order.order_extra ? order.order_extra : {}"
      @confirm="selectShopAddress = $event"
      isActivity
    />
    <DialogImages
      v-model="qualifyReportDialog"
      :img_url="
        currentItem && currentItem.qualify_report_img_url
          ? currentItem.qualify_report_img_url
          : []
      "
    />
    <StockMaterialsSelectsDialog
      v-model="stockMaterialsDialog"
      :stock-id="
        stock_outs.stock_id && stock_outs.type ? stock_outs.stock_id : null
      "
      :disabledItems="stock_out_details"
      :status="[1]"
      :typeFlg="'stockOrdersOut'"
      @confirm="selectMaterials = $event"
    />

    <ImportExcelDialog
      v-model="importDialog"
      :objName="$t('StockOrderOUT.ObjectName')"
      @import="
        excelFile = $event;
        importExcel();
      "
      :stock_id="(stock_outs.stock_id && stock_outs.type) ? stock_outs.stock_id : null"
    />

    <v-dialog v-model="memo_dialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          <span
            class="red--text d-inline-block text-truncate"
            style="max-width: 360px"
          >
            {{
              $t("Material.materialNameWithCode", [
                detail_memo_item.material_code,
                detail_memo_item.material_name,
              ])
            }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="memo_dialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 pt-8">
          <v-textarea
            v-model="detail_memo_item.memo"
            outlined
            :label="$t('Order.DetailFields.memo')"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="memo_dialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import StockOuts from "@/api/stock_outs";
import StockOrderOUTActions from "./plugins/Actions";
import ErrorMaterialsAlert from "./plugins/ErrorMaterialsAlert";
import SearcherStock from "@/components/plugins/SearcherStock";
import SearcherStockMaterial from "@/components/plugins/SearcherStockMaterial";
import NumberInput from "@/components/plugins/NumberInput";
import AddressText from "@/components/plugins/AddressText";
import MaterialDialog from "@/components/materials/plugins/Dialog";
import SearcherSupplier from "@/components/plugins/SearcherSupplier";
import Required from "@/components/plugins/Required";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Files from "@/api/files";
import StockMaterials from "@/api/stock_materials";
import DialogShopAddress from "@/components/plugins/DialogShopAddress";
import Orders from "@/api/orders";
import DialogImages from "@/components/plugins/DialogImages";
import StockMaterialsSelectsDialog from "@/components/plugins/StockMaterialsSelectsDialog";
import SearcherAccountUser from "@/components/plugins/SearcherAccountUser";
import Requisitions from "@/api/requisitions";
import ImportExcelDialog from "./plugins/ImportExcelDialog";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetime,
    StockOrderOUTActions,
    ErrorMaterialsAlert,
    SearcherStock,
    SearcherStockMaterial,
    NumberInput,
    AddressText,
    MaterialDialog,
    Required,
    ValidationObserver,
    ValidationProvider,
    SearcherSupplier,
    DialogShopAddress,
    DialogImages,
    StockMaterialsSelectsDialog,
    SearcherAccountUser,
    ImportExcelDialog,
  },
  computed: {
    stock_id() {
      return this.stockSelected ? this.stockSelected.id : null;
    },
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return (
        !this.preview &&
        (this.mode == "new" || this.mode == "edit" || this.mode == "out")
      );
    },
    isStockOut() {
      return this.mode == "out";
    },
    isNew() {
      return this.mode == "new";
    },
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: this.productionStockOUTFlg
            ? i18n.t("Nav.productionManagement")
            : this.orderStockOUTFlg
            ? i18n.t("Nav.orderManagement")
            : i18n.t("Nav.stockManagement"),
          disabled: false,
          replace: true,
          href: this.productionStockOUTFlg
            ? "/production-plans"
            : this.orderStockOUTFlg
            ? "/orders"
            : "/stocks",
        },
        {
          text: this.productionStockOUTFlg
            ? i18n.t("Nav.productionStockOUT")
            : this.orderStockOUTFlg
            ? i18n.t("Nav.ordersStockOrdersOut")
            : i18n.t("Nav.stockOrdersOut"),
          disabled: false,
          href: this.productionStockOUTFlg
            ? "/production-stock-out"
            : this.orderStockOUTFlg
            ? "/order-stock-out"
            : "/stock-orders-out",
        },
        {
          text: this.isNew
            ? i18n.t("Nav.stockOutsNew")
            : this.productionStockOUTFlg
            ? i18n.t("Nav.productionStockOUTDetail")
            : i18n.t("Nav.stockOutDetail"),
          disabled: true,
        },
      ];
      if (!this.isNew) {
        items.push({
          text:
            this.stock_outs && this.stock_outs.stock_order_code
              ? this.stock_outs.stock_order_code
              : "",
          disabled: false,
          accent: true,
        });
      }
      return items;
    },

    detailsHeaders() {
      var headers = [
        {
          text: i18n.t("StockOrderOUT.DetailFields.category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("StockOrderOUT.DetailFields.material_code"),
          align: "start",
          value: "material_code",
        },
        {
          text: i18n.t("StockOrderOUT.DetailFields.material"),
          align: "start",
          value: "Description",
        },
        {
          text: i18n.t("StockOrderOUT.DetailFields.current_count"),
          align: "center",
          value: "current_count",
        },
        {
          text: i18n.t("StockOrderOUT.DetailFields.unit"),
          align: "end",
          value: "unit",
        }
      ];
      if (!this.productionStockOUTFlg) {
        headers.push({
          text: i18n.t("StockOrderOUT.DetailFields.stock_out_order_num"),
          align: "end",
          value: "order_num",
        });
      }

      if (
        this.isView ||
        (!this.isNew &&
          (this.stock_outs.type == 1 ||
            this.stock_outs.type == 2 ||
            this.stock_outs.type == 13 ||
            this.productionStockOUTFlg))
      ) {
        if (
          (!this.isNew &&
            (this.stock_outs.type == 1 || this.productionStockOUTFlg)) ||
          this.isView
        ) {
          headers.push({
            text: i18n.t("StockOrderOUT.DetailFields.stock_out_confirm_num"),
            align: "end",
            value: "confirm_num",
          });
        }
        if (this.isView || (!this.isNew && !this.productionStockOUTFlg)) {
          headers.push({
            text: i18n.t("StockOrderOUT.DetailFields.stock_out_practical_num"),
            align: "end",
            value: "out_num",
          });
        }
      }

      if (this.settings && this.settings.count_unit == 1) {
        headers.push({
          text: i18n.t("StockOrderOUT.DetailFields.count_unit"),
          align: "end",
          value: "count_unit",
        });
      }

      if (this.stock_outs.type == 1) {
        headers.push({
          text: i18n.t("StockOrderOUT.DetailFields.stock_confirm_num"),
          align: "end",
          value: "stock_confirm_num",
        });
      }

      if (this.stock_outs.requisition_flg == 1) {
        headers.push({
          text: i18n.t("StockOrderOUT.DetailFields.requisition_price"),
          align: "end",
          value: "requisition_price",
        });
      }

      if (
          this.isView ||
          this.mode == "edit" ||
          this.mode == "new" ||
          (this.isStockOut && this.stock_outs.type != 2)
      ) {
        headers.push({
          text: i18n.t("StockOrderOUT.DetailFields.stock_out_price"),
          align: "end",
          value: "price",
        });
      }

      if (
        this.isView &&
        this.settings &&
        this.settings.qualify_report_enable == 1 &&
        this.settings.out_qualify_report_enable == 1
      ) {
        headers.push({
          text: i18n.t("PurchasesDetail.purchaseFields.qualify_report"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "qualify_report_img",
        });
      }

      // if (this.settings && this.settings.product_date_setting) {
      //   headers.push(
      //     {
      //       text: i18n.t("StockOrderOUT.DetailFields.production_date"),
      //       align: "start",
      //       value: "production_date",
      //       width: 136,
      //     },
      //     {
      //       text: i18n.t("StockOrderOUT.DetailFields.expired_date"),
      //       align: "start",
      //       value: "expired_date",
      //       width: 136,
      //     }
      //   );
      // }
      // 退货出库响应采购小计设置
      if (this.stock_outs.type == 13) {
        headers.push({
          text: i18n.t("StockOrderOUT.DetailFields.total"),
          align: "end",
          value: "total",
        });
      }
      if (this.stock_outs.type != 1 && !this.productionStockOUTFlg && !this.orderStockOUTFlg) {
        headers.push({
          text: i18n.t("StockOrderOUT.DetailFields.memo"),
          align: "center",
          sortable: false,
          value: "memo",
          width: 180
        });
      }
      headers.push({
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      });

      return headers;
    },
    activitiesHeaders: () => [
      {
        text: i18n.t("StockOrderOUT.ActivityFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("StockOrderOUT.ActivityFields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("StockOrderOUT.ActivityFields.operater"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],
    relationsHeaders() {
      var headers = [
        {
          text: i18n.t("Order.RelationFields.identify_name"),
          align: "center",
          sortable: false,
          value: "relations_name",
        },
      ];
      if (this.stock_outs.type == 2 || this.stock_outs.type == 13) {
        headers.push({
          text: i18n.t("Order.RelationFields.identify_code"),
          align: "center",
          sortable: false,
          value: "identify_code",
        });
      } else {
        headers.push({
          text: i18n.t("Order.RelationFields.identify_code"),
          align: "center",
          sortable: false,
          value: "stock_take_code",
        });
      }
      headers.push(
        {
          text: i18n.t("Order.RelationFields.creater"),
          align: "start",
          sortable: false,
          value: "creater_name",
        },
        {
          text: i18n.t("Order.RelationFields.created_time"),
          align: "start",
          sortable: false,
          value: "created",
        }
      );
      if (this.stock_outs.type == 4) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }
      return headers;
    },
    stockOutDetails() {
      return this.stock_out_details.map((detail) => {
        detail.Description = i18n.t(
          this.settings
            ? this.settings.material_name_display_type == 4
              ? "Material.nameWithCodeAndStandard"
              : this.settings.material_name_display_type == 3
              ? "Material.materialNameWithCodeAndStandard"
              : this.settings.material_name_display_type == 2
              ? "Material.materialNameWithCode"
              : "Material.materialName"
            : "Material.materialName",
          [
            detail.material_code,
            detail.material_name,
            detail.new ? detail.material.standard_name : detail.standard_name,
          ]
        );
        if (this.editMemoData && detail.id == this.editMemoData.id) {
          detail.edit_memo = 1;
        }else {
          detail.edit_memo = 0;
        }
        return detail;
      });
    },
    isSubDisabled() {
      //开启分账，不能修改商品数量
      return !!(
        this.settings.sub_account_enable &&
        (this.settings.sub_account_modify_enable != 1 ||
          (this.settings.sub_account_modify_enable == 1 &&
            !(
              this.isStockOut &&
              this.stock_outs.type == 1 &&
              this.$permission.permissionAllow("StockOuts", "partOut")
            ) &&
            this.subAccountEditStatus &&
            this.subAccountEditStatus.shop_bill != 19 &&
            this.subAccountEditStatus.sub_account_status.edit_num == 0 &&
            this.order_bill &&
            this.order_bill.bill &&
            (this.order_bill.bill.pay_flg == 2 ||
              this.order_bill.bill.pay_flg == 3)))
      );
    },
    isAddMaterialEnable() {
      // 开启分账， 能够增加新商品的情况
      return !!(
        this.settings.sub_account_enable &&
        this.settings.sub_account_modify_enable == 1 &&
        this.subAccountEditStatus &&
        (this.subAccountEditStatus.shop_bill == 19 ||
          (this.subAccountEditStatus.shop_bill != 19 &&
            this.order_bill &&
            this.order_bill.bill &&
            this.order_bill.bill.pay_flg == 1))
      );
    },
    isEditNumEnable() {
      // 开启分账且订单商品数据可以修改，对账单类型不为要货下单且是只可增加且是部分支付或已支付要货单做限制
      return !!(
        this.settings &&
        this.settings.sub_account_enable &&
        this.settings.sub_account_modify_enable == 1 &&
        !(
          this.isStockOut &&
          this.stock_outs.type == 1 &&
          this.$permission.permissionAllow("StockOuts", "partOut")
        ) &&
        this.subAccountEditStatus &&
        this.subAccountEditStatus.shop_bill != 19 &&
        this.subAccountEditStatus.sub_account_status.edit_num == 1 &&
        this.order_bill &&
        this.order_bill.bill &&
        (this.order_bill.bill.pay_flg == 2 || this.order_bill.bill.pay_flg == 3)
      );
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings", "subAccountEditStatus"]),
  },

  mounted() {
    if (this.$route.path.startsWith("/stock-orders-out/new")) {
      this.productionStockOUTFlg = false;
      this.orderStockOUTFlg = false;
      this.mode = "new";
    } else {
      this.mode = this.$route.params.mode;
      // 调拨出库
      if (this.$route.query.outType) {
        this.outType = this.$route.query.outType;
      }
      if (this.$route.path.startsWith("/production-stock-out")) {
        this.productionStockOUTFlg = true;
        this.orderStockOUTFlg = false;
        if (this.mode) {
          this.$router.replace(
            "/production-stock-out/" + this.$route.params.id
          );
        }
      } else if (this.$route.path.startsWith("/stock-orders-out")) {
        this.productionStockOUTFlg = false;
        this.orderStockOUTFlg = false;
        if (this.$route.query.broken_type) {
          this.brokenType = this.$route.query.broken_type;
        } else {
          this.brokenType = null;
        }
        if (this.mode || this.brokenType) {
          this.$router.replace("/stock-orders-out/" + this.$route.params.id);
        }
      } else if (this.$route.path.startsWith("/order-stock-out")) {
        this.productionStockOUTFlg = false;
        this.orderStockOUTFlg = true;
        if (this.mode) {
          this.$router.replace("/order-stock-out/" + this.$route.params.id);
        }
      }
    }
    this.sortArr = JSON.parse(localStorage.getItem("stockOutSort"));
    this.sortDescArr = JSON.parse(localStorage.getItem("stockOutSortDesc"));
  },

  data: () => ({
    productionStockOUTFlg: false,
    orderStockOUTFlg: false,
    panels: [0],
    tab: null,
    filter: "",
    mode: "",
    stock_outs: {},
    receiverInfo: {},
    stock_out_details: [],
    stock_out_activities: [],
    stockSelected: null,
    datetimeRage: [new Date()],
    standard_detail: null,
    addMaterial: null,
    addMaterials: [],
    selectMaterial: null,
    selectMaterials: [],
    dialogMaterialID: null,
    replaceStock: false,
    errorMaterialInfoAlert: false,
    errorMaterialsList: [],
    errorMsg: "",
    album: [],
    imgs_file: [],
    imgsRules: [
      (value) =>
        !value ||
        value.filter((v) => v.size >= 10000000).length == 0 ||
        i18n.t("Material.imgsHint"),
    ],
    total: 0,
    outType: "",
    relations: [],
    order_bill: {},
    selectShopAddressDialog: false,
    selectShopAddress: null,
    order: null,
    qualifyReportDialog: false,
    currentItem: null,
    production_plan_relations: [],
    supplier: null,
    stockMaterialsDialog: false,
    editExpectDateFlg: false,
    edit_estimated_express: false,
    edit_attachment: false,
    edit_express_price: false,
    sortArr: [],
    sortDescArr: [],
    express_price: null,
    brokenType: null,
    importDialog: false,
    excelFile: null,
    editMemoData: null,
    memo_dialog: false,
    memo_dialog_memo: "",
    detail_memo_item: { memo: "" },
  }),

  methods: {
    getStockOutsFromAPI() {
      var options = {
        order_activity: 1,
      };
      if (
        (this.$route.path.startsWith("/stock-orders-out") ||
        this.$route.path.startsWith("/order-stock-out")) && (this.brokenType != 5)
      ) {
        options = Object.assign({}, options, {
          merge_detail: 1,
        });
      }
      StockOuts.fetchOne(this.$route.params.id, options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_outs = response.data.stock_out;
            this.receiverInfo = response.data.order_address;
            this.order = response.data.order;
            this.stockSelected = { id: response.data.stock_out.stock_id };
            this.stock_out_activities = response.data.order_activities;
            this.album = response.data.stock_out.img;
            this.stock_outs.order_num_count = 0;
            this.stock_outs.confirm_num_count = 0;
            this.stock_outs.out_num_count = 0;
            this.express_price = this.stock_outs.requisition
              ? this.stock_outs.requisition.express_price
              : null;
            if (this.stock_outs.status == 1) {
              this.total = this.stock_outs.total_price;
            } else if (
              this.stock_outs.status == 2 ||
              this.stock_outs.status == 3
            ) {
              this.total = this.stock_outs.total_confirm_price;
            }
            if (this.stock_outs.type == 2) {
              this.relations = [];
              if (this.stock_outs.requisition) {
                this.relations.push(
                  Object.assign(
                    {
                      controller: "Requisitions",
                      identify: "requisitions",
                      identify_name: i18n.t("Requisition.ObjectName"),
                      creater_name: this.stock_outs.requisition.operater_name,
                      identify_code: this.stock_outs.requisition.requisition_code,
                    },
                      this.stock_outs.requisition
                  )
                );
                console.log('relations', this.relations)
              }
            }
            if (this.stock_outs.type == 3) {
              this.relations = [];
              this.relations.push(this.stock_outs.stock_take);
            }
            if (this.stock_outs.type == 1) {
              this.getOrderFromAPI(this.stock_outs.order_id);
            }
            if (this.stock_outs.type == 4) {
              this.production_plan_relations = [];
              this.production_plan_relations.push(
                Object.assign(
                  {
                    controller: "ProductionPlans",
                    identify: "production-plans",
                    identify_name: i18n.t("ProductionPlans.ObjectName"),
                    creater_name: this.stock_outs.creater_name,
                    identify_code:
                      response.data.stock_out.production_plan.production_code,
                  },
                  response.data.stock_out.production_plan
                )
              );
            }
            if (this.stock_outs.type == 13) {
              if (this.stock_outs.bill) {
                this.relations.push(
                  Object.assign(
                    {
                      controller: "Receipt",
                      identify: "receipts",
                      identify_name: i18n.t("Bill.ObjectName"),
                      creater_name: this.stock_outs.bill.creater_name,
                      identify_code: this.stock_outs.bill.bill_code,
                    },
                    this.stock_outs.bill
                  )
                );
              }
              if (
                this.stock_outs.finance_bill &&
                this.settings &&
                this.settings.finance_bill_enable == 1
              ) {
                this.relations.push(
                  Object.assign(
                    {
                      controller: "FinanceBills",
                      identify: "finance-bills-purchaseReturn",
                      identify_name: i18n.t(
                        "ReceiptBillAnalyze.billTypes.billTypePurchase"
                      ),
                      creater_name: this.stock_outs.finance_bill.creater_name,
                      identify_code:
                        this.stock_outs.finance_bill.finance_bill_code,
                    },
                    this.stock_outs.finance_bill
                  )
                );
              }
            }

            this.stock_outs.stock_order_details.forEach((detail) => {
              if (this.stock_outs.type == 2) {
                // 调拨出库 更新单价
                detail.price = detail.avg_price;
              }
              //单位换算
              if (
                detail.stock_unit_id !=
                detail.material.standard.default_standard_detail.id
              ) {
                //库存单位换算
                if (detail.current_count) {
                  //库存量不为零
                  //大单位取整
                  var current_quantity_int = parseInt(
                    detail.current_count / detail.stock_unit_rate
                  );
                  //取余
                  if (detail.current_count % detail.stock_unit_rate) {
                    var current_quantity_decimal =
                      detail.current_count % detail.stock_unit_rate;
                    detail.current_quantity_with_unit = i18n.t(
                      "Stock.stockQuantityWithMultipleUnits",
                      [
                        current_quantity_int,
                        detail.stock_unit,
                        this.$numberFormatter.formatTwoDot(
                          current_quantity_decimal
                        ),
                        detail.material.standard.default_standard_detail.unit,
                      ]
                    );
                  } else {
                    detail.current_quantity_with_unit = i18n.t(
                      "Stock.stockQuantity",
                      [current_quantity_int, detail.stock_unit]
                    );
                  }
                } else {
                  detail.current_quantity_with_unit = i18n.t(
                    "Stock.stockQuantity",
                    [detail.current_count, detail.stock_unit]
                  );
                }
              } else {
                detail.current_quantity_with_unit = i18n.t(
                  "Stock.stockQuantity",
                  [detail.current_count, detail.stock_unit]
                );
              }
              //基准单位
              detail.current_count_with_unit = i18n.t("Stock.stockQuantity", [
                detail.current_count,
                detail.material.standard.default_standard_detail.unit,
              ]);

              if (this.isStockOut) {
                if (detail.is_sorting == 1) {
                  detail.out_num = detail.sorting_num;
                } else {
                  detail.out_num = detail.confirm_num;
                }
              }

              //申请出库量总计
              this.stock_outs.order_num_count += detail.order_num;
              this.stock_outs.confirm_num_count += detail.confirm_num;
              this.stock_outs.out_num_count += detail.out_num;
            });
          }
        }.bind(this)
      );
    },

    async doSubmit(out_type) {
      this.$store.dispatch("fullscreenLoading");
      // 检查一下图片上传的error，拒绝上传
      if (this.isNew) {
        if (this.$refs.imgs_file && this.$refs.imgs_file.hasError) {
          this.$store.dispatch("fullscreenLoadingStop");
          return;
        }
        //提交图片集
        var examine_img = [];
        if (this.imgs_file && this.imgs_file.length > 0) {
          let response = await Files.imagesUpload(
            this.imgs_file,
            false,
            "images",
              true
          );

          if (response.data.status.isOK()) {
            response.data.data.forEach((img) => examine_img.push(img.img_name));
          }
        }
      }

      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            if (this.mode == "edit") {
              this.submitUploadImg();
              let postData = Object.assign({}, this.stock_outs);
              StockOuts.edit(this.stock_outs.id, postData)
                .then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.$refs.observer.reset();
                      if (
                        !this.productionStockOUTFlg &&
                        !this.orderStockOUTFlg
                      ) {
                        this.$router.push("/stock-orders-out");
                      } else if (this.productionStockOUTFlg) {
                        this.$router.push("/production-stock-out");
                      } else {
                        this.$router.push("/order-stock-out");
                      }
                    } else if (
                      response.data.error &&
                      response.data.data.length
                    ) {
                      this.errorMaterialInfoAlert = true;
                      this.errorMaterialsList = response.data.data;
                      if (response.data.error.code == "ERR752") {
                        this.errorMsg = i18n.t(
                          "StockOrderOUT.Messages.some_materials_no_exist"
                        );
                      } else if (response.data.error.code == "ERR810") {
                        this.errorMsg = i18n.t(
                          "StockOrderOUT.Messages.negative_inventory_out_err"
                        );
                      }
                    }
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                )
                .catch(
                  function () {
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                );
            }
            if (this.mode == "new") {
              let isSubmite = true;
              if (this.stock_outs.type == 13) {
                if (this.stock_outs.supplier) {
                  this.stock_outs.supplier_id = this.stock_outs.supplier.id;
                } else {
                  isSubmite = false;
                  this.$snackbar.error(
                    i18n.t("StockOrderOUT.Messages.supplier_required_msg")
                  );
                }
              }

              if (isSubmite) {
                StockOuts.add(
                  Object.assign({}, this.stock_outs, { img: examine_img })
                )
                  .then(
                    function (response) {
                      if (response.data.status.isOK()) {
                        this.$refs.observer.reset();
                        if (
                          !this.productionStockOUTFlg &&
                          !this.orderStockOUTFlg
                        ) {
                          this.$router.push("/stock-orders-out");
                        } else if (this.productionStockOUTFlg) {
                          this.$router.push("/production-stock-out");
                        } else {
                          this.$router.push("/order-stock-out");
                        }
                      } else if (
                        response.data.error &&
                        response.data.data.length &&
                        response.data.error.code == "ERR810"
                      ) {
                        this.errorMaterialInfoAlert = true;
                        this.errorMaterialsList = response.data.data;
                        this.errorMsg = i18n.t(
                          "StockOrderOUT.Messages.negative_inventory_out_err"
                        );
                      }
                      this.$store.dispatch("fullscreenLoadingStop");
                    }.bind(this)
                  )
                  .catch(
                    function () {
                      this.$store.dispatch("fullscreenLoadingStop");
                    }.bind(this)
                  );
              } else {
                this.$store.dispatch("fullscreenLoadingStop");
              }
            }
            if (this.isStockOut) {
              this.submitUploadImg();
              this.stock_out_details.forEach((detail) => {
                if (!this.productionStockOUTFlg) {
                  detail.confirm_num = detail.out_num;
                }
              });
              if (out_type == "out") {
                StockOuts.out(this.stock_outs)
                  .then(
                    function (response) {
                      if (response.data.status.isOK()) {
                        this.$refs.observer.reset();
                        if (
                          !this.productionStockOUTFlg &&
                          !this.orderStockOUTFlg
                        ) {
                          if (this.outType == "requisitionOut") {
                            this.$router.push("/requisitions");
                          } else {
                            this.$router.push("/stock-orders-out");
                          }
                        } else if (this.productionStockOUTFlg) {
                          this.$router.push("/production-stock-out");
                        } else {
                          this.$router.push("/order-stock-out");
                        }
                        this.$store.commit("refreshToDos", true);
                      } else if (
                        response.data.error &&
                        response.data.data.length
                      ) {
                        this.errorMaterialInfoAlert = true;
                        this.errorMaterialsList = response.data.data;
                        if (response.data.error.code == "ERR752") {
                          this.errorMsg = i18n.t(
                            "StockOrderOUT.Messages.some_materials_no_exist"
                          );
                        } else if (response.data.error.code == "ERR810") {
                          this.errorMsg = i18n.t(
                            "StockOrderOUT.Messages.negative_inventory_out_err"
                          );
                        }
                      }
                      this.$store.dispatch("fullscreenLoadingStop");
                    }.bind(this)
                  )
                  .catch(
                    function () {
                      this.$store.dispatch("fullscreenLoadingStop");
                    }.bind(this)
                  );
              } else if (out_type == "part_out") {
                StockOuts.partOut(this.stock_outs)
                  .then(
                    function (response) {
                      if (response.data.status.isOK()) {
                        this.$refs.observer.reset();
                        if (
                          !this.productionStockOUTFlg &&
                          !this.orderStockOUTFlg
                        ) {
                          if (this.outType == "requisitionOut") {
                            this.$router.push("/requisitions");
                          } else {
                            this.$router.push("/stock-orders-out");
                          }
                        } else if (this.productionStockOUTFlg) {
                          this.$router.push("/production-stock-out");
                        } else {
                          this.$router.push("/order-stock-out");
                        }
                        this.$store.commit("refreshToDos", true);
                      } else if (
                        response.data.error &&
                        response.data.data.length
                      ) {
                        this.errorMaterialInfoAlert = true;
                        this.errorMaterialsList = response.data.data;
                      }
                      this.$store.dispatch("fullscreenLoadingStop");
                    }.bind(this)
                  )
                  .catch(
                    function () {
                      this.$store.dispatch("fullscreenLoadingStop");
                    }.bind(this)
                  );
              }
            }
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    removeFromImages(i) {
      this.album.splice(i, 1);
      this.imgs_file.splice(i, 1);
    },
    getOrderFromAPI(order_id) {
      Orders.fetchOne(order_id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.order_bill = response.data.order;
          }
        }.bind(this)
      );
    },
    addMaterialDetail(addMaterial, isFromImport = false) {
      //获取库存单位
      var standard_detail = addMaterial.standard_detail_id
        ? addMaterial.standard_details.find(
            (standard_detail) =>
              standard_detail.id == addMaterial.standard_detail_id
          )
        : "";
      //判断库存单位是否是默认单位
      var current_quantity_with_unit = "";
      var current_count_with_unit = "";
      if (!standard_detail.default_flg) {
        var standard_detail_default = addMaterial.standard_details.find(
          (standard_detail) => standard_detail.default_flg == 1
        );

        //库存单位与默认单位转换
        if (addMaterial.current_count) {
          //库存量不为零
          //大单位取整
          var current_quantity_int = parseInt(
            addMaterial.current_count / standard_detail.rate
          );
          //小单位取余
          if (addMaterial.current_count % standard_detail.rate) {
            var current_quantity_decimal =
              addMaterial.current_count % standard_detail.rate;
            current_quantity_with_unit = i18n.t(
              "Stock.stockQuantityWithMultipleUnits",
              [
                current_quantity_int,
                standard_detail.unit,
                current_quantity_decimal,
                standard_detail_default.unit,
              ]
            );
          } else {
            current_quantity_with_unit = i18n.t("Stock.stockQuantity", [
              current_quantity_int,
              standard_detail.unit,
            ]);
          }
        } else {
          //库存量为零
          current_quantity_with_unit = i18n.t("Stock.stockQuantity", [
            addMaterial.current_count,
            standard_detail.unit,
          ]);
        }
      } else {
        current_quantity_with_unit = i18n.t("Stock.stockQuantity", [
          addMaterial.current_count,
          standard_detail.unit,
        ]);
      }
      current_count_with_unit = i18n.t("Stock.stockQuantity", [
        addMaterial.current_count,
        addMaterial.default_standard_detail.unit,
      ]);

      if (isFromImport) {
        console.log()
        //导入商品单价取接口
        standard_detail.supply_price = addMaterial.out_price;
      }

      this.stock_out_details.push({
        new: this.stock_out_details.length + 1,
        stock_out_id: this.stock_outs.id,
        category_name: addMaterial.category_name,
        material_id: addMaterial.material_id,
        material_code: addMaterial.material_code,
        material_name: addMaterial.material_name,
        standard_name: addMaterial.standard ? addMaterial.standard.name : "",
        unit: addMaterial.unit,
        standard_detail_unit: standard_detail.unit,
        current_count_with_unit: current_count_with_unit,
        current_quantity_with_unit: current_quantity_with_unit,
        price: standard_detail.supply_price,
        order_num: (isFromImport) ? addMaterial.order_num : '',
        memo: null,
        standard_detail: addMaterial.standard_detail,
        standard_details: addMaterial.standard_details,
        material: addMaterial,
        standard_detail_id: addMaterial.standard_detail_id,
        stock_unit: addMaterial.unit,
        stock_unit_rate: addMaterial.standard_detail.rate,
        stock_current_count: addMaterial.current_count,
        total: (isFromImport) ? addMaterial.total : "",
      });
    },
    async submitUploadImg() {
      // 检查一下图片上传的error，拒绝上传
      if (this.$refs.imgs_file && this.$refs.imgs_file.hasError) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }

      //提交图片集
      var stock_out_img = [];
      if (this.imgs_file && this.imgs_file.length > 0) {
        let response = await Files.imagesUpload(
          this.imgs_file,
          false,
          "images",
            true
        );

        if (response.data.status.isOK()) {
          response.data.data.forEach((img) => stock_out_img.push(img.img_name));
          StockOuts.update({
            stock_order_code: this.stock_outs.stock_order_code,
            img: stock_out_img,
          })
            .then(
              function () {
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            )
            .catch(
              function () {
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            );
        }
      }
    },
    editExpectDate() {
      if (!this.stock_outs.expect_date) {
        this.$snackbar.error(i18n.t("Order.messages.editExpectDateError"));
        return;
      }
      this.$store.dispatch("fullscreenLoading");
      Orders.update({
        order_code: this.stock_outs.order_code,
        expect_date: this.stock_outs.expect_date,
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.editExpectDateFlg = false;
              this.$snackbar.success(
                i18n.t("Order.messages.editExpectDateSuccess")
              );
              this.getStockOutsFromAPI();
              this.$store.dispatch("fullscreenLoadingStop");
            }
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    saveEstimatedExpress() {
      this.$store.dispatch("fullscreenLoading");
      StockOuts.editEstimatedExpress(this.stock_outs.id, {
        estimated_express: this.stock_outs.estimated_express,
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.edit_estimated_express = false;
              this.$snackbar.success(
                i18n.t("Order.messages.editEstimatedExpressSuccess")
              );
              this.getStockOutsFromAPI();
              this.$store.dispatch("fullscreenLoadingStop");
            }
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    saveExpressPrice() {
      this.$store.dispatch("fullscreenLoading");
      Requisitions.editExpressPrice({
        stock_out_id: this.stock_outs.id,
        express_price: this.express_price,
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.edit_express_price = false;
              this.$snackbar.success(
                i18n.t("Order.messages.editExpressPriceSuccess")
              );
              this.getStockOutsFromAPI();
              this.$store.dispatch("fullscreenLoadingStop");
            }
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    saveAttachment(data = null) {
      let postData = {}
      if (data) {
        postData = {
          stock_order_code: this.stock_outs.stock_order_code,
          stock_order_details: [{
            id: data.id,
            memo: data.memo
          }]
        }
      }else {
        postData = {
          stock_order_code: this.stock_outs.stock_order_code,
          attachment: this.stock_outs.attachment
        }
      }
      this.$store.dispatch("fullscreenLoading");
      StockOuts.update(postData).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (data) {
              this.editMemoData = null;
            } else {
              this.edit_attachment = false;
            }
            this.$snackbar.success(i18n.t("StockOrderOUT.Messages.saveAttachmentSuccess"));
            this.getStockOutsFromAPI();
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      ).catch(
        function () {
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
    setEditMemoFlg(data) {
      if (this.editMemoData && this.editMemoData.id != data.id) {
        // 未保存且切换待修改单据时
        this.stock_out_details = this.stock_out_details.map((deail) => {
          if (deail.id == this.editMemoData.id) {
            deail.memo = this.editMemoData.memo;
          }
          return deail;
        })
      }
      this.editMemoData = Object.assign({}, data);
    },
    resetPrice(data) {
      this.stock_out_details.forEach((detail) => {
        if (detail.material_id == data.material_id) {
          // 找到对应的商品后根据单位重新修改单价
          let standard_detail = data.standard_detail_id
            ? data.standard_details.find((d) => d.id == data.standard_detail_id)
            : null;
          if (standard_detail) {
            let price = standard_detail.supply_price;
            detail.price = this.$numberFormatter.formatMoney(price);
          }
        }
      });
    },
    importExcel() {
      this.$store.dispatch("fullscreenLoading");
      StockOuts.imports(this.excelFile, this.stock_outs.stock_id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.info(i18n.t("Import.success", [i18n.t("StockOrderOUT.title")]));
            this.importDialog = false;
            if (response.data.materials && response.data.materials.length) {
              response.data.materials.forEach((addMaterial) => {
                this.addMaterialDetail(addMaterial, true);
              });
            }
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      ).catch(
        function () {
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
  },

  watch: {
    sortDescArr: {
      handler() {
        if (this.sortDescArr == null) {
          this.sortDescArr = [];
        }
        localStorage.setItem(
          "stockOutSortDesc",
          JSON.stringify(this.sortDescArr)
        );
      },
    },
    sortArr: {
      handler() {
        if (this.sortArr == null) {
          this.sortArr = [];
        }
        localStorage.setItem("stockOutSort", JSON.stringify(this.sortArr));
      },
    },
    $route(to) {
      this.selectShopAddressDialog = false;
      if (to.path.startsWith("/stock-orders-out/new")) {
        this.mode = "new";
        // 重新初始化界面
        this.panels = [0];
        this.tab = null;
        this.stock_outs = {
          stock_order_details: [],
          order_num_count: 0,
          confirm_num_count: 0,
          detail_length: 0,
        };
        this.stock_out_activities = [];
        this.filter = "";
        this.addMaterial = null;
        this.selectMaterial = null;
        this.addMaterials = [];
        this.selectMaterials = [];
      } else if (to.params.mode) {
        this.mode = to.params.mode;
        if (!this.productionStockOUTFlg && !this.orderStockOUTFlg) {
          this.$router.replace("/stock-orders-out/" + to.params.id);
        } else if (this.productionStockOUTFlg) {
          this.$router.replace("/production-stock-out/" + to.params.id);
        } else {
          this.$router.replace("/order-stock-out/" + to.params.id);
        }
      }
    },
    mode: {
      handler() {
        this.edit_attachment = false
        if (this.isNew) {
          this.stock_outs.actual_date = this.$datetimeUtils.formatTime(
            new Date()
          );
        } else if (this.$route.params.id) {
          if (this.isStockOut) {
            // 解决明细页点出库时实际出库数量带出缓慢问题
            if (this.stock_out_details) {
              this.stock_out_details.forEach((detail) => {
                detail.out_num = detail.confirm_num;
              });
            }
          }
          this.getStockOutsFromAPI();
        }
      },
    },
    stockSelected: {
      handler() {
        if (this.stockSelected) {
          if (this.isNew) {
            this.stock_outs = Object.assign({}, this.stock_outs, {
              stock_id: this.stockSelected.id,
              stock_order_details: [],
              order_num_count: 0,
              confirm_num_count: 0,
              detail_length: 0,
            });
          } else if (this.mode == "edit" || this.isStockOut) {
            this.stock_outs.stock_id = this.stockSelected.id;
          }
        }
      },
    },
    stock_outs: {
      handler() {
        this.stock_out_details =
          this.stock_outs && this.stock_outs.stock_order_details
            ? this.stock_outs.stock_order_details
            : [];
      },
    },
    stock_out_details: {
      deep: true,
      handler() {
        var order_num_count = 0;
        var confirm_num_count = 0;
        var out_num_count = 0;
        var total = 0;
        this.stock_out_details.forEach((detail) => {
          if (detail.order_num > 0) {
            order_num_count += Number(detail.order_num);
          }
          if (detail.confirm_num > 0) {
            confirm_num_count += Number(detail.confirm_num);
          }
          if (detail.out_num > 0) {
            out_num_count += Number(detail.out_num);
          }
          if (
            this.settings &&
            this.settings.purchase_subtotal == 1 &&
            this.stock_outs.type == 13
          ) {
            // 计算退货出库单价
            total += Number(detail.total);
            detail.price =
              detail.order_num != 0
                ? this.$numberFormatter.formatWithDotNoMoreThan(
                    Number(detail.total) / Number(detail.order_num),
                    2
                  )
                : 0;
          } else if (this.isView) {
            total = this.total;
          } else {
            if (this.isNew) {
              total +=
                Number(detail.order_num ? detail.order_num : 0) *
                Number(detail.price);
              if (this.stock_outs.type == 13) {
                detail.total = this.$numberFormatter.formatMoneyFloor(
                  Number(detail.order_num ? detail.order_num : 0) *
                    Number(detail.price),
                  2
                );
              }
            } else {
              if (!(this.stock_outs.type == 1 || this.stock_outs.type == 2)) {
                if (this.stock_outs.type == 13 && this.mode == "out") {
                  total +=
                    Number(detail.out_num ? detail.out_num : 0) *
                    Number(detail.price);
                  detail.total = this.$numberFormatter.formatMoneyFloor(
                    Number(detail.out_num ? detail.out_num : 0) *
                      Number(detail.price),
                    2
                  );
                } else {
                  total +=
                    Number(detail.order_num ? detail.order_num : 0) *
                    Number(detail.price);
                  detail.total = this.$numberFormatter.formatMoneyFloor(
                    Number(detail.order_num ? detail.order_num : 0) *
                      Number(detail.price),
                    2
                  );
                }
              } else {
                if (this.stock_outs.type == 2) {
                  total += Number(detail.confirm_num) * Number(detail.price);
                } else if (this.stock_outs.type == 1 && this.isStockOut) {
                  // 订单出库解决精度问题(退一取整)
                  total += parseFloat(
                    this.$numberFormatter.formatMoneyFloor(
                      parseFloat(
                        (Number(detail.out_num) * Number(detail.price)).toFixed(
                          4
                        )
                      )
                    )
                  );
                  total = parseFloat(total.toFixed(2));
                } else {
                  total += parseFloat(
                    this.$numberFormatter.formatMoneyFloor(
                      parseFloat(
                        (
                          Number(detail.confirm_num) * Number(detail.price)
                        ).toFixed(4)
                      )
                    )
                  );
                  total = parseFloat(total.toFixed(2));
                }
              }
            }
          }
        });
        this.stock_outs.order_num_count = order_num_count;
        this.stock_outs.confirm_num_count = confirm_num_count;
        this.stock_outs.out_num_count = out_num_count;
        this.total = total;
      },
    },
    selectMaterial: {
      handler() {
        if (this.selectMaterial && this.selectMaterial.id) {
          if (!this.stock_outs.type) {
            this.$snackbar.info(
              i18n.t("StockOrderOUT.Messages.stock_out_type_error")
            );
            this.selectMaterial = null;
            return;
          }
          let postData = {
            stock_id: this.stock_outs.stock_id,
            readonly: 0,
            out_type: this.stock_outs.type,
            material_ids: this.selectMaterial.material_id,
            material_code: this.selectMaterial.material_code,
            shop_id: this.stock_outs.shop_id ? this.stock_outs.shop_id : "",
          };
          if (this.stock_outs.type == 13 && this.stock_outs.supplier) {
            postData.supplier_id = this.stock_outs.supplier.id;
          }

          StockMaterials.fetchAllForSelect(postData).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.addMaterial = response.data.materials[0];
              }
            }.bind(this)
          );
        }
      },
    },
    selectMaterials: {
      handler() {
        if (this.selectMaterials && this.selectMaterials.length) {
          if (!this.stock_outs.type) {
            this.$snackbar.info(
              i18n.t("StockOrderOUT.Messages.stock_out_type_error")
            );
            this.selectMaterials = [];
            return;
          }
          let postData = {
            stock_id: this.stock_outs.stock_id,
            readonly: 0,
            out_type: this.stock_outs.type,
            material_ids: this.selectMaterials.map(
              (selectMaterial) => selectMaterial.material_id
            ),
            shop_id: this.stock_outs.shop_id ? this.stock_outs.shop_id : "",
          };
          if (this.stock_outs.type == 13 && this.stock_outs.supplier) {
            postData.supplier_id = this.stock_outs.supplier.id;
          }

          StockMaterials.fetchAllForSelect(postData).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.addMaterials = response.data.materials;
              }
            }.bind(this)
          );
        }
      },
    },

    addMaterial: {
      handler() {
        if (this.addMaterial && this.addMaterial.id) {
          this.addMaterialDetail(this.addMaterial);
          this.selectMaterial = {
            id: 0,
            material_code: "",
            material_name: "",
            standard_name: "",
          };
          this.addMaterial = {
            id: 0,
            material_code: "",
            material_name: "",
            standard_name: "",
          }; //消除显示
        }
      },
    },
    addMaterials: {
      handler() {
        if (this.addMaterials && this.addMaterials.length) {
          this.addMaterials.forEach((addMaterial) => {
            this.addMaterialDetail(addMaterial);
          });
        }
      },
    },
    errorMaterialInfoAlert: {
      handler() {
        if (!this.errorMaterialInfoAlert && this.errorMaterialsList.lrngth) {
          this.errorMaterialsList = [];
        }
      },
    },
    imgs_file: {
      deep: true,
      handler() {
        if (this.imgs_file.length) {
          if (this.imgs_file.length > 3) {
            this.$snackbar.error(i18n.t("Examine.DetailFields.hint"));
            this.album = [];
            this.imgs_file = [];
          } else {
            this.album = [];
            this.imgs_file.forEach((img) => {
              var reader = new FileReader();
              reader.readAsDataURL(img);
              let that = this;
              reader.onload = function () {
                that.album.push(this.result);
              };
            });
          }
        } else {
          this.album = this.stock_outs.img ? this.stock_outs.img : [];
        }
      },
    },
    selectShopAddress: {
      handler() {
        if (this.selectShopAddress) {
          this.receiverInfo.user_name = this.selectShopAddress.name;
          this.receiverInfo.tel = this.selectShopAddress.phone;
          this.receiverInfo.address =
            this.selectShopAddress.province_name +
            this.selectShopAddress.city_name +
            this.selectShopAddress.area_name +
            this.selectShopAddress.address;
          let orderExtra = {
            express: {
              receiver_name: this.selectShopAddress.name,
              receiver_phone: this.selectShopAddress.phone,
              receiver_province: this.selectShopAddress.province_name,
              receiver_city: this.selectShopAddress.city_name,
              receiver_area: this.selectShopAddress.area_name,
              receiver_address: this.selectShopAddress.address,
            },
          };
          this.order.order_extra = orderExtra;
          if (this.stock_outs.order_id) {
            //存在要货订单时，直接更新数据
            Orders.updateOrdersExtras(
              this.stock_outs.order_id,
              this.selectShopAddress
            ).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.$snackbar.success(
                    i18n.t("Order.messages.orderExtrasSuccess")
                  );
                }
              }.bind(this)
            );
          }
        }
      },
    },
    supplier: {
      handler() {
        this.stock_outs.supplier = this.supplier;
        let material_ids = [];
        if (
          this.supplier &&
          this.stock_out_details.length > 0 &&
          this.stock_outs.stock_id &&
          this.stock_outs.type == 13
        ) {
          material_ids = this.stock_out_details.map((d) => d.material_id);
          let postData = {
            stock_id: this.stock_outs.stock_id,
            readonly: 0,
            out_type: this.stock_outs.type,
            material_ids: material_ids,
            shop_id: this.stock_outs.shop_id ? this.stock_outs.shop_id : "",
            supplier_id: this.stock_outs.supplier.id,
          };
          StockMaterials.fetchAllForSelect(postData).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.stock_out_details.forEach((d) => {
                  d.price = response.data.materials.find(
                    (v) => v.material_id == d.material_id
                  ).supply_price;
                });
              }
            }.bind(this)
          );
        }
      },
    },
    detail_memo_item: {
      handler() {
        if (this.detail_memo_item) {
          if (this.savable && this.detail_memo_item.delivery_date_flg) {
            if (
                this.detail_memo_item.memo &&
                this.detail_memo_item.memo.length >= 10
            ) {
              this.memo_dialog_memo = this.detail_memo_item.memo.substring(11);
            } else {
              this.memo_dialog_memo = this.detail_memo_item.memo ? this.detail_memo_item.memo : "";
            }
          } else {
            this.memo_dialog_memo = this.detail_memo_item.memo ? this.detail_memo_item.memo : "";
          }
        }
      },
    },
  },
};
</script>